import React, { useState, useCallback } from "react";
import { Modal, Button } from "react-bootstrap";
import Cropper from 'react-easy-crop';
import { getCroppedImgDetails } from './canvasUtils'
import PropTypes from "prop-types";

const ImageCropper = (props) => {

  const { cropImg, fileToImage } = props;
  const [crop, setCrop] = useState({ x: 0, y: 0 })
  const [zoom, setZoom] = useState(1)
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null)
  const [rotation] = useState(0);
const ASPECT_RATIO = 1;
  const onCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels)
  }, [])

  const showCroppedImage = useCallback(async () => {
    try {
      const croppedImage = await getCroppedImgDetails(
        cropImg,
        croppedAreaPixels,
        rotation
      )
      fileToImage(croppedImage)
      props.onHide()
    } catch (e) {
      console.error(e)
    }
  }, [cropImg, croppedAreaPixels, rotation])

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static" className="cropper-modal"
    >
      <Modal.Header closeButton></Modal.Header>
      <Modal.Body>

        <div className="crop-container">
          <Cropper
            image={cropImg}
            crop={crop}
            zoom={zoom}
            aspect={ASPECT_RATIO}
            onCropChange={setCrop}
            onCropComplete={onCropComplete}
            onZoomChange={setZoom}
          />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div className="controls">
          <Button
            onClick={showCroppedImage}
            variant="contained"
            color="primary"
          >
            Crop & Set
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

ImageCropper.propTypes = {
  cropImg: PropTypes.string.isRequired,
  fileToImage: PropTypes.func.isRequired,
  onHide: PropTypes.func.isRequired,
  show: PropTypes.bool,
};

export default ImageCropper;
